export enum AUTH_TYPE {
  API_KEY = "api-key",
  BEARER = "bearer"
}
